import { useShelvingStore } from "../store";
import shallow from "zustand/shallow";
import { SectionInterface } from "../store/types/store";
import { useRoomSizes } from "./useRoomSizes";



function useButtonPosition(yLevel: 'bottom' | 'middle' | 'custom') {
    const getCurrentShelving = useShelvingStore((state) => state.getCurrentShelving, shallow);
    const roomSizes = useRoomSizes();
    const currentShelving = getCurrentShelving();
    const currentSide = currentShelving.name;

    const sideSizes = {
        totalHeight: currentShelving.height,
        offsetCeiling: currentShelving.offsetCeiling,
        sideIndent: currentShelving.sideIndent
    }

    let y = (
        roomSizes.roomHeight
        - sideSizes.totalHeight
        - sideSizes.offsetCeiling
    ) / 1000;

    if (yLevel === 'middle') {
        y = (roomSizes.roomHeight - sideSizes.totalHeight / 2 - sideSizes.offsetCeiling) / 1000
    }

    return (section: SectionInterface, buttonY: number | null) => {
        if (yLevel === 'custom' && buttonY !== null) {
            y = buttonY
        }

        if (currentSide === 'left') return [
            - roomSizes.roomLength / 2000,
            y,
            ((roomSizes.roomDepth - sideSizes.sideIndent) / 1000) - (section.offset + section.width / 2) / 1000,
        ]

        if (currentSide === 'right') return [
            roomSizes.roomLength / 2000,
            y,
            ((sideSizes.sideIndent) / 1000) + (section.offset + section.width / 2) / 1000,
        ]

        if (currentSide === 'back') return [
            (roomSizes.roomLength / 2 - sideSizes.sideIndent) / 1000 - (section.offset + section.width / 2) / 1000,
            y,
            roomSizes.roomDepth / 1000,
        ]

        return [
            - (roomSizes.roomLength / 2 - sideSizes.sideIndent) / 1000 + (section.offset + section.width / 2) / 1000,
            y,
            0,

        ]
    }
}

export default useButtonPosition
